import React            from 'react';
import HeaderBackground from '../../Media/HeaderBG.png';
import HeaderArrow      from '../../Media/HeaderArrow.webp';
import "./Header.css";

const Header = ({scroll}) => {
    return (
        <div className = "header" style = {{backgroundImage:    `url(${HeaderBackground})`,
                                            backgroundRepeat:   "repeat-y",
                                            backgroundSize:     "110vw",
                                            backgroundPosition: "50% 0",
                                            backgroundColor:    "#000000"}}>

            <p>   Fikirlerin, Sovos’un Global Gücüyle Buluşsun<br/>
            <span>Sen de Dönüşümün Parçası Ol!</span>
            </p>

            <p   className = "explore"      onClick = {()=> scroll(document.getElementsByClassName("details")[0])} tabIndex = {0}>Keşfet</p>
            <img className = "exploreArrow" onClick = {()=> scroll(document.getElementsByClassName("details")[0])} tabIndex = {0} src = {HeaderArrow} alt = "" />
        </div>
    )
}

export default Header;